var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-close",on:{"click":function($event){return _vm.$emit('click-event')}}},[_c('span',{staticClass:"btn-close"})])}
var staticRenderFns = []

export { render, staticRenderFns }